import { useContext } from "react";
import { AppContext } from "../context/context";

function DemoVideo() {
  const { state, setState } = useContext(AppContext);

  return (
    <div
      onClick={() => setState({ ...state, showDemo: false })}
      className="fixed w-full h-screen z-50 inset-0 flex items-center justify-center bg-black/50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[300px] smd:w-[500px] smd:h-[295px] lg:w-[690px] lg:h-[400px] rounded-xl bg-white p-4"
      >
        <div className="relative w-full h-full">
          <iframe
            className="w-full h-full rounded-md"
            src="https://www.youtube.com/embed/-Q2TbhBTWNw"
            title="YouTube video"
            // frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default DemoVideo;
